import { createApp } from 'vue'
import StarterKitContentsApp from '@/apps/StarterKitContentsApp.vue'

export default function () {
  document.querySelectorAll('[data-starter-kit-contents]').forEach((el) => {
    el.addEventListener('click', () => {
      const template = document.querySelector(
        '[data-starter-kit-contents-modal-content]',
      ) as HTMLTemplateElement
      const app = createApp(StarterKitContentsApp, {
        title: template.dataset.starterKitContentsModalTitle,
        config: JSON.parse(template.dataset.starterKitContentsData as string),
      })
      app.mount('#modal-container')
    })
  })
}
